"use client";

import { c as _c } from "react/compiler-runtime";
import { ComboboxItem, JollyComboBox } from "@/components/rac/combobox";
import { type Country, getCountriesWithPhoneCodes } from "@/info/countries";
interface CountrySelectorProps {
  selectedCountry: Country;
  onCountryChange: (country: Country) => void;
  isDisabled?: boolean;
  hideLabel?: boolean;
}
export function CountrySelector(t0) {
  const $ = _c(29);
  const {
    selectedCountry,
    onCountryChange,
    isDisabled: t1,
    hideLabel: t2
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  const hideLabel = t2 === undefined ? false : t2;
  let T0;
  let t10;
  let t11;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== hideLabel || $[1] !== isDisabled || $[2] !== onCountryChange || $[3] !== selectedCountry.countryCode) {
    const countries = getCountriesWithPhoneCodes();
    t11 = hideLabel ? "mb-2" : "mb-4";
    T0 = JollyComboBox;
    t3 = "Country";
    t4 = "Search countries...";
    t5 = "focus";
    t6 = selectedCountry.countryCode;
    t7 = key => {
      if (key) {
        const country = countries.find(c => c.countryCode === key);
        if (country) {
          onCountryChange(country);
        }
      }
    };
    t8 = isDisabled;
    t9 = "w-full";
    let t12;
    if ($[14] !== hideLabel) {
      t12 = country_0 => <ComboboxItem key={country_0.countryCode} id={country_0.countryCode} textValue={`${country_0.flag}  ${hideLabel ? "" : country_0.name} ${country_0.code}`} className="flex items-center gap-3 py-2 px-3 cursor-pointer data-[focused]:bg-gray-100 data-[selected]:bg-blue-50 rounded-md"><span className="text-base">{country_0.flag}</span><div className="flex justify-between w-full">{!hideLabel && <span className="text-sm font-medium">{country_0.name}</span>}<span className="text-xs text-gray-500">{country_0.code}</span></div></ComboboxItem>;
      $[14] = hideLabel;
      $[15] = t12;
    } else {
      t12 = $[15];
    }
    t10 = countries.map(t12);
    $[0] = hideLabel;
    $[1] = isDisabled;
    $[2] = onCountryChange;
    $[3] = selectedCountry.countryCode;
    $[4] = T0;
    $[5] = t10;
    $[6] = t11;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    T0 = $[4];
    t10 = $[5];
    t11 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  let t12;
  if ($[16] !== T0 || $[17] !== t10 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t12 = <T0 label={t3} placeholder={t4} menuTrigger={t5} selectedKey={t6} onSelectionChange={t7} isDisabled={t8} className={t9}>{t10}</T0>;
    $[16] = T0;
    $[17] = t10;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}